
<template>

	<mymodal ref="modal" title="Настройка доверительного интервала" ok="Сохранить" :reset="reset" :check="check" :submit="submit">

		<b-form-group class="mt-2" v-for="( attr, index ) in data.modeling.attrs.filter(attr => attr.type == 'number')" :key="index" :label="attr.name">

			<b-form-input type="number" v-model="in_data.modeling.attrs_confidences[attr.id]"/>

		</b-form-group>

	</mymodal>

</template>

<script>

import api from "../../../../../api/"
import mymodal from "../../../../widgets/modal"

export default
{
	props :
	{
		cost_evaluation_id : String,
		data : Object,
	},

	components :
	{
		mymodal,
	},

	watch :
	{
		data :
		{
			immediate : true,
			deep : true,

			handler(data)
			{
				if(data)
					this.in_data = api.deep_clone(data)
			}
		},
	},

	data()
	{
		return {

			in_data : { modeling : { attrs_confidences : {}, attrs : [] } },

		}
	},

	methods :
	{
		check()
		{
			return true
		},

		reset()
		{
		},

		execute()
		{
			this.$refs.modal.execute()
		},

		submit()
		{
			var fields = {}

			Object.entries(this.in_data.modeling.attrs_confidences).forEach(
				elem =>
				{
					const value = Number(elem[1])
					const key = "modeling.attrs_confidences." + elem[0]

					fields[key] = value
				})

			this.$emit("edit", { fields : fields })
			this.$emit("input", this.in_data.modeling.attrs_confidences)
		}
	}
}

</script>

